import { type EditorPlugin } from '../../types/aha-editor';

const LinkSchemaPlugin: EditorPlugin = {
  name: 'Link schema plugin',
  schema: {
    link: {
      isInline: true,
    },
  },
};

export default LinkSchemaPlugin;
